import JsBundleList from "~src/components/jsBundleList";
import * as React from 'react';
export default {
  JsBundleList,
  React
};